import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from '../../services/error.service';
import { RouteTrackingService } from '../../services/route-tracking.service';
import { SnackbarService } from '../../services/snackbar.service';
import { DateTime } from 'luxon';

@Component({
	selector: 'app-complete-route-modal',
	templateUrl: './complete-route-modal.html'
})

export class CompleteRouteModalComponent implements OnInit {
	public form: UntypedFormGroup;
	public id: any;
	public rowVersion: string;

	constructor(private _routeTrackingService: RouteTrackingService,
				private _vcRef: ViewContainerRef,
				private _errorService: ErrorService,
				public dialogRef: MatDialogRef<CompleteRouteModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder,
				private _snackbarService: SnackbarService) {

		this.id = data.id;
		this.rowVersion = data.rowVersion;
	}

	close(response) {
		this.dialogRef.close(response);
	}

	completeStop() {
	if (this.form.valid && DateTime.fromFormat(`${this.form.value.completedDate.toFormat('yyyy-LL-dd')} ${this.form.value.completedTime}`, 'yyyy-LL-dd HH:mm').isValid) {
    const formattedDateTime = DateTime.fromFormat(`${this.form.value.completedDate.toFormat('yyyy-LL-dd')} ${this.form.value.completedTime}`, 'yyyy-LL-dd HH:mm').toMillis();
			this._routeTrackingService.updateRouteStop(this.id, formattedDateTime, this.form.value.name, 'COMPLETED', this.rowVersion).subscribe(() => {
				this._routeTrackingService.getRouteStopDetail(this.id, true, true, true).subscribe((response: any) => {
					this.close({...response});
				}, (error) => {
					this._errorService.error(error, 'getRouteStopDetail Failed', 'modal');
					this.close(null);
				});
			}, error => {
				this._errorService.error(error, 'updateRouteStop failed', 'modal');
			});
		} else {
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}

	onTimeSet(event: any): void {
		const a = event.split(' ')[0].split(':');

		// Set hours
		(<HTMLInputElement>(
			document.getElementsByClassName('timepicker-dial__control')[0]
		)).value = ('0' + a[0]).slice(-2);

		// Set minutes
		(<HTMLInputElement>(
			document.getElementsByClassName('timepicker-dial__control')[1]
		)).value = a[1];
	}

	ngOnInit(): void {
		this.form = this._formBuilder.group({
			name: ['', [Validators.required]],
			completedDate: ['', [Validators.required]],
			completedTime: ['', [Validators.required]],
		});
	}
}
